module.exports = __webpack_public_path__ + "img/product-placeholder-35.a4f9608.png";